/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import { IconDownload, IconEye, IconPlus } from "@tabler/icons-react";
import ListView from "../../../components/common/ListView";
import NormalSearch from "../../../components/common/NormalSearch";
import DropdownFilter from "../../../components/common/DropdownFilter";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import CommonModal from "../../../components/common/CommonModal";
import AddCountryModal from "./AddCountryModal";
import CountryEditViewModal from "./CountryEditViewModal";
import formatDate from '../../../utilities/helper';
import { useForm } from "react-hook-form";
import { useCountriesCreateMutation, useIntegrationData } from "../../../apis/locationApis";
import toast from "react-hot-toast";
import IntegrationSkeleton from "../../../components/skeleton/IntegrationSkeleton";
import Pagination from "../../../components/common/Pagination";
import useDebounce from "../../../utilities/useDebounce";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";

interface Country {
  id: string;
  name: string;
  currencyCode: string;
  countryCode: string;
  dialCode: number;
  date: string;
  hubs?: number;
  cities?: number;
}

export default function CountryListTab() {
  const [credential, setCredential] = useState<boolean>(false);
  const [searchFor, setSearchFor] = useState<string>("");
  const [pageNo, setPageNo] = useState<number>(1); // ✅ new state
  const [country, setCountry] = useState<Country>({
    id: "",
    name: "",
    countryCode: "",
    currencyCode: "",
    dialCode: 0,
    date: "",
    hubs: 0,
    cities: 0
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { mutate, isPending: isRequestPending } = useCountriesCreateMutation();
  const { data, isSuccess, isPending, refetch, isFetching } = useIntegrationData(pageNo, searchFor);

  const debouncedSearchFor = useDebounce(searchFor, 550);

  useEffect(() => {
    refetch(); // Trigger on search or page change
  }, [debouncedSearchFor, pageNo]);

  const credentialToggleModal = () => setCredential(!credential);

  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const handleCountryCreate = (data: any) => {
    mutate(
      { ...data, type: "LM" },
      {
        onSuccess: () => {
          setCredential(false);
          refetch();
        },
        onError: (error: any) => {
          console.error(error);
          toast.error(error?.response?.data?.message || "Something went wrong");
        },
      }
    );
  };

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  return (
    <>
      <div className="bg-[#F7F6F2] rounded-3xl">
        <div className="flex justify-between items-center w-full  p-4">
          <div className="flex justify-between items-center rounded-tl-3xl rounded-tr-3xl">
            <h1 className="text-3xl text-[#212121]">Country</h1>
          </div>
          <div className="flex items-center gap-2 justify-end rounded-full">
            <div className="flex items-center gap-2">
              <ColumnsFilter columnsData={[]} />
              <DropdownFilter filterheadings={[]} />
              <NormalSearch
                value={searchFor}
                onChange={(e) => {
                  setSearchFor(e.target.value);
                  setPageNo(1); // Reset to page 1 on search
                }}
              />
            </div>

            <button
              onClick={credentialToggleModal}
              className="flex items-center gap-1 p-2 text-sm rounded-full border border-[#D8D8D8] bg-white"
            >
              <IconPlus stroke={1.5} size={20}/>
            </button>
            <button className="p-2 text-sm rounded-full border border-[#D8D8D8] bg-white">
              <IconDownload stroke={1.5}  size={20}/>
            </button>
          </div>
        </div>

        {isPending ? (
          <TableSkeleton
            columns={[
              "S/N",
              "Country",
              "Country Code",
              "Currency Code",
              "Dial Code",
              "Cities",
              "Created Date",
              "Actions",
            ]}
            rows={6}
          />
        ) : (
          <ListView
            data={data?.countries}
            onRowClick={(client) => console.log("Clicked:", client)}
            columns={[
              { label: "#", render: (_, i) => i + 1 },
              {
                label: "Country",
                render: (c: any) => (
                  <div className="flex items-center gap-2 truncate max-w-xs">
                    <span className="truncate text-base font-medium">
                      {c.name}
                    </span>
                  </div>
                ),
              },
              { label: "Country Code", render: (c:any) => c.countryCode },
              { label: "Currency Code", render: (c:any) => c.currencyCode },
              { label: "Dial Code", render: (c:any) => c.dialCode },
              { label: "Cities", render: (c:any) => c.cities },
              { label: "Created Date", render: (c:any) => formatDate(c.date) },
              {
                label: "Actions",
                render: (c:any) => (
                  <button
                    onClick={() => {
                      setCountry(c);
                      openModal();
                    }}
                    className="p-2 border rounded-full bg-[#F7F6F2]"
                  >
                    <IconEye />
                  </button>
                ),
              },
            ]}
          />
        )}

        {data?.totalPages > 1 && (
          <Pagination totalPages={data.totalPages} fetchData={handlePaginationFetch} currentPage={pageNo} />
        )}
      </div>

      <CommonModal
        title={"Add new Country"}
        open={credential}
        closeButtonText={"Cancel"}
        onClose={credentialToggleModal}
        actionButtonText="Add Country"
        actionButtonOnClick={handleSubmit(handleCountryCreate)}
        actionButtonProps={{ disabled: isRequestPending }}
      >
        <AddCountryModal register={register} errors={errors} />
      </CommonModal>

      <CountryEditViewModal open={isOpen} onClose={closeModal} country={country} fetchData={refetch} />
    </>
  );
}
